import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import React from "react";
import "react-day-picker/dist/style.css";
import ReactDOM from "react-dom/client";
import { SciChart3DSurface, SciChartSurface } from "scichart";

import "@/api/config/config";
import "@/polyfill/json-polyfill";

import App from "./app";
import "./i18n";
import "./index.css";
import reportWebVitals from "./report-web-vitals";

dayjs.extend(utc);
dayjs.extend(duration);

SciChartSurface.UseCommunityLicense();
SciChartSurface.loadWasmFromCDN();
SciChart3DSurface.loadWasmFromCDN();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  /*<React.StrictMode>*/
  <App />
  /*</React.StrictMode>*/
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
